import { createBrowserRouter, redirect, RouterProvider } from 'react-router-dom'
import { VideoWaitingRoom } from '@/pages/waiting-room/VideoWaitingRoom'
import { WaitingRoomDemo } from '@/pages/waiting-room/WaitingRoomDemo'
import { VideoMeetingPage } from '@/pages/meeting/VideoMeeting'
import { MeetingDemoPage } from '@/pages/meeting/MeetingDemo'
import { VideoMeetingLeftPage } from '@/pages/meeting-left/VideoMeetingLeft'
import { ErrorBoundary } from '@components/organisms/ErrorBoundary/ErrorBoundary'
import { AppLayout } from './layouts/AppLayout'
import { prejoinLoader } from './loaders/prejoinLoader'
import { phoneMeetingRedirectLoader, videoMeetingRedirectLoader } from './loaders/meetingRedirectLoader'
import { ROUTES } from '@constants/routes'
import { PhoneWaitingRoom } from '@/pages/waiting-room/PhoneWaitingRoom'
import { JoinPhoneMeetingPage } from '@/pages/meeting/JoinPhoneMeeting'
import { PhoneMeetingPage } from '@/pages/meeting/PhoneMeeting'
import { PhoneMeetingLeftPage } from '@/pages/meeting-left/PhoneMeetingLeft'

const router = createBrowserRouter([
  {
    element: <AppLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: ROUTES.videoWaitingRoom(':id'),
        element: <VideoWaitingRoom />,
        loader: prejoinLoader
      },
      {
        path: ROUTES.phoneWaitingRoom(':id'),
        element: <PhoneWaitingRoom />,
        loader: prejoinLoader
      },
      {
        path: ROUTES.joinPhoneMeeting(':id'),
        element: <JoinPhoneMeetingPage />,
        loader: prejoinLoader
      },
      {
        path: ROUTES.videoMeeting(':appointmentId', ':meetingId'),
        element: <VideoMeetingPage />,
        loader: videoMeetingRedirectLoader
      },
      {
        path: ROUTES.phoneMeeting(':appointmentId', ':meetingId'),
        element: <PhoneMeetingPage />,
        loader: phoneMeetingRedirectLoader
      },
      {
        path: ROUTES.videoMeetingLeft,
        element: <VideoMeetingLeftPage />
      },
      {
        path: ROUTES.phoneMeetingLeft,
        element: <PhoneMeetingLeftPage />
      },
      {
        path: '/meeting/demo',
        element: <MeetingDemoPage />
      },
      {
        path: '/appointment/demo',
        element: <WaitingRoomDemo />
      },
      {
        path: '/appointment/:id',
        loader: ({ params }) => redirect(`/video/${params.id}`)
      }
    ]
  }
])

export function AppRoutes() {
  return <RouterProvider router={router} />
}
